<template>
  <select-case-related-request></select-case-related-request>
</template>

<script>
import SelectCaseRelatedRequest from '../components/select-case-related-request/index.vue';

export default { components: { SelectCaseRelatedRequest } };

</script>
